module.exports = __webpack_public_path__ + "media/images/lp/1/history4-sp-309e827e9be84498a982b243ee332b8b.jpg";